import * as React from "react";

function SvgRefPlate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 30V2.833H4.25L0 7.083V30h34zM24 7h6v6h-6V7zm6 13h-6v6h6v-6zM4 20h6v6H4v-6zm6-13H4v6h6V7z"
        fill="#F7A246"
      />
    </svg>
  );
}

export default SvgRefPlate;
